import { z } from 'zod';

export const HandleSchema = z
    .string()
    .trim()
    .min(2, 'Pick at least 2 characters')
    .max(20, 'Keep it under 20 characters')
    .regex(/^[a-zA-Z0-9_]+$/, 'Letters, numbers and underscores only');

export const PinSchema = z.string().regex(/^\d{4,8}$/, 'Use 4 to 8 digits');

export const PlayerSchema = z.object({
    id: z.number().int().positive(),
    handle: z.string().min(1),
});

export type Player = z.infer<typeof PlayerSchema>;

// The endpoint answers "is this link usable" rather than failing, so an
// expired link renders an explanation instead of an error page.
export const InviteInfoSchema = z.discriminatedUnion('valid', [
    z.object({
        valid: z.literal(true),
        // Null when the link has no use limit.
        remainingUses: z.number().int().nonnegative().nullable(),
        hangoutName: z.string().nullable(),
        players: z.array(PlayerSchema),
    }),
    z.object({
        valid: z.literal(false),
        reason: z.string(),
    }),
]);

export type InviteInfo = z.infer<typeof InviteInfoSchema>;
